module.exports = __webpack_public_path__ + "static/img/A-symbol-for-solutions_Maskbook.65ce3c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/A-symbol-for-solutions_Maskbook.jpg
// module id = KosO
// module chunks = 0